import script from "./PathList.vue?vue&type=script&setup=true&lang=js"
export * from "./PathList.vue?vue&type=script&setup=true&lang=js"

import "./PathList.vue?vue&type=style&index=0&id=2a77aaf6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a77aaf6"]])

export default __exports__